module.exports = __webpack_public_path__ + "static/img/AI-5.780fe42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AI-5.jpg
// module id = lc9H
// module chunks = 36